import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class InitiativesStatusPillIndexComponent extends Component {
  @service betaToggle;
}
